module.exports = __webpack_public_path__ + "img/resourcesbg1.ec1360ec.png";